import { View } from "ui/atoms/view";
import { FormControlledDatePicker } from "ui/molecules/form/FormControlledDatePicker";
import { useForm } from "react-hook-form";
import { Button, ButtonText } from "ui/gluestack/button";

interface Props {
  onConfirm: (dates: { date_from?: string; date_to?: string }) => void;
  onClose: () => void;
}

export default function AuditLogsExportTemplate({ onConfirm, onClose }: Props) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      date_from: undefined,
      date_to: undefined,
    },
  });

  const submitDatesAndStartExport = handleSubmit((values) => {
    onConfirm(values);
    onClose();
  });
  return (
    <View className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-9">
      <FormControlledDatePicker
        id="date_from"
        name="date_from"
        control={control}
        label="Start date"
        placeholder={"00/00/0000"}
        isRequired
      />
      <FormControlledDatePicker
        id="date_to"
        name="date_to"
        control={control}
        label="End date"
        placeholder={"00/00/0000"}
        isRequired
      />
      <View className="col-span-full">
        <View className="flex justify-end gap-4 sm:flex-row sm:gap-x-4 mt-10">
          <Button action="primary" size="sm" variant="outline" onPress={onClose}>
            <ButtonText>Cancel</ButtonText>
          </Button>
          <Button
            action="primary"
            size="sm"
            onPress={submitDatesAndStartExport}
          >
            <ButtonText className="text-white">Export</ButtonText>
          </Button>
        </View>
      </View>
    </View>
  );
}
